import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Card, Form, Select } from 'antd'

const FormItem = Form.Item
const { Option } = Select

const JoinUsPositionStep = ({ form, profile, positions }) => {
  const { getFieldDecorator } = form

  const handleSelectChange = value => {
    console.log(value)
    form.setFieldsValue({
      position: value,
    })
  }

  if (isEmpty(profile))
    return (
      <React.Fragment>
        <Card title="Select Position" type="inner">
          <FormItem
            label="Position"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator('position', {
              initialValue: null,
            })(
              <Select
                placeholder="Select a job position"
                size="large"
                style={{ width: 300 }}
                onChange={handleSelectChange}
              >
                {positions
                  ? positions.map(pos => (
                      <Option key={pos.name} value={pos.name}>
                        {pos.name}
                      </Option>
                    ))
                  : null}
              </Select>
            )}
          </FormItem>
        </Card>
      </React.Fragment>
    )

  return (
    <React.Fragment>
      <Card title="Select Position" type="inner">
        <FormItem
          label="Position"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('position', {
            initialValue: profile.position ? profile.position : null,
          })(
            <Select
              placeholder="Select a job position"
              size="large"
              style={{ width: 300 }}
              onChange={handleSelectChange}
            >
              {positions
                ? positions.map(pos => (
                    <Option key={pos.name} value={pos.name}>
                      {pos.name}
                    </Option>
                  ))
                : null}
            </Select>
          )}
        </FormItem>
      </Card>
    </React.Fragment>
  )
}

export default JoinUsPositionStep
